<template>
    <FilterItem
        v-qa="filter.metal.translation.name.replace('ct', 'K')"
        class="filter-item-metal"
        :add-link="addLink"
        :disabled="disabled"
        :label="filter.metal.translation.name"
        :remove-link="removeLink"
        :selected="selected"
        :total-results="totalResults"
    >
        <div
            :class="classMetalIcon"
            class="metal-icon"
        ></div>
    </FilterItem>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type { MetalFilterFragment } from '@/graphql/api'
import { getClassMetalVariation } from '@/views/product/getClassMetalVariation'
import type { ButtonRouteRelative } from '@/components/ui/buttons/useThButton'

import FilterItem from './FilterItem.vue'

const props = defineProps<{
    filter: MetalFilterFragment
    selected?: boolean
    addLink?: ButtonRouteRelative
    removeLink?: ButtonRouteRelative
    totalResults: number
    disabled?: boolean
}>()

const classMetalIcon = computed(() => ({
    [getClassMetalVariation(props.filter.metal.systemCode)]: true,
}))
</script>

<style lang="scss" scoped>
.filter-item-metal {
    .metal-icon {
        --side: 32px;
        width: var(--side);
        height: var(--side);

        display: block;

        &::before {
            content: '';
            width: var(--side);
            height: var(--side);
            background: linear-gradient(-45deg, #c2c1c2, #edebed);
            display: block;
            border-radius: 50%;
        }

        &.yellow-gold {
            &::before {
                background: linear-gradient(-45deg, #b49d69, #e7d9b2);
            }
        }

        &.rose-gold {
            &::before {
                background: linear-gradient(-45deg, #d8a49d, #f8e5e3);
            }
        }

        &.white-gold {
            &::before {
                background: linear-gradient(-45deg, #d8d8d8, #fefefe);
            }
        }
    }
}
</style>
